<template>
<div>
<h3 class="mt-4">{{ $t('Projects by location') }}</h3>
  <div class="row">
    <div class="col-3">
    <fieldset>
      <legend>{{  $t('Map layer')  }}</legend>
      <p>{{ $t('map description') }}</p>
      <div class="custom-control custom-radio">
        <input type="radio" id="greenfieldRadio" name="greenfieldRadio" class="custom-control-input" v-model="currentFillMap" value="greenfield">
        <label class="custom-control-label" for="greenfieldRadio">{{ $t('Greenfield') }}</label>	
      </div>
      <div class="custom-control custom-radio">
        <input type="radio" id="povertyRadio" name="povertyRadio" class="custom-control-input" v-model="currentFillMap" value="high_poverty_area">
        <label class="custom-control-label" for="povertyRadio">{{ $t('High poverty areas') }}</label>	
      </div>
      <div class="custom-control custom-radio">
        <input type="radio" id="wardRadio" name="wardRadio" class="custom-control-input" v-model="currentFillMap" value="wards">
        <label class="custom-control-label" for="wardRadio">{{ $t('Wards') }}</label>	
      </div>
      <div class="custom-control custom-radio">
        <input type="radio" id="intensificationRadio" name="intensificationRadio" class="custom-control-input" v-model="currentFillMap" value="intensification_targets">
        <label class="custom-control-label" for="intensificationRadio">{{ $t('Intensification targets') }}</label>	
      </div>
    </fieldset>
    <fieldset>
      <legend>{{  $t('Growth type')  }}</legend>
      <div class="custom-control custom-radio">
        <input type="radio" id="allRadio" name="allRadio" class="custom-control-input" v-model="growthType" value="All">
        <label class="custom-control-label" for="allRadio">{{ $t('All investments') }}</label>	
      </div>
      <div class="custom-control custom-radio">
        <input type="radio" id="growthEnabledRadio" name="growthEnabledRadio" class="custom-control-input" v-model="growthType" value="Growth-enabling infrastructure">
        <label class="custom-control-label" for="growthEnabledRadio">{{ $t('Growth-enabling infrastructure') }}</label>	
      </div>
      <div class="custom-control custom-radio">
        <input type="radio" id="growSupportedRadio" name="growSupportedRadio" class="custom-control-input" v-model="growthType" value="Growth-supportive infrastructure">
        <label class="custom-control-label" for="growSupportedRadio">{{ $t('Growth-supportive infrastructure') }}</label>	
      </div>
      <div class="custom-control custom-radio">
        <input type="radio" id="higherPovertyRadio" name="higherPovertyRadio" class="custom-control-input" v-model="growthType" value="Higher Poverty Area" @click="currentFillMap='high_poverty_area'">
        <label class="custom-control-label" for="higherPovertyRadio">{{ $t('High poverty areas') }}</label>	
      </div>
    </fieldset>
    <fieldset>
      <legend>{{ $t('Legend') }}</legend>
      <h5 class="mt-2">{{ $t('investments') }}</h5>
      <span><i class="fa fa-circle dsred"></i> {{ $t('Not funded investments') }}<br/></span>
      <span><i class="fa fa-circle dsyellow"></i> {{ $t('Partially funded investments') }}<br/></span>
      <span><i class="fa fa-circle dsgreen"></i> {{ $t('Fully funded investments') }}<br /></span>
      <span><br /></span>
      <h5 class="mt-2">{{ $t(currentFillMap + '_label') }}</h5>
      <span v-for="(label, index) in geometry_labels" :key="`label_${index}`"><i class="fa fa-square" :style="`color: ${geometry_colours[index]}`"></i> {{ label }}<br /></span>
    </fieldset>
    </div>
    <div class="col-9">
      <GmapMap :center="centre" :zoom="zoom" style="width: 100%; height: 600px" ref="map" class="box">
        <GmapPolygon v-for="(polygon,index) in polygons" :key="'poly_' + index" :paths="polygon" :editable="false" :clickable="true" :options="geometry_options[index]" @click="polygon_clicked(polygon, index)"></GmapPolygon>
        <GmapMarker v-for="(location,index) in location_records" :key="'marker_' + index" :position="location.position" :options="marker_options(location)" :clickable="true" @click="marker_clicked(location, index)"></GmapMarker>
        <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false"></gmap-info-window>
      </GmapMap>
    </div>
  </div>
  <p>{{ $t('map-disclaimer') }}</p>
  <div v-if="citywide_records.length">
    <h3 class="mt-4">{{ $t('Citywide projects') }}</h3>
    <TableResults 
      :sortColumn="sort.column" 
      :direction="sort.direction" 
      :records="citywide_records" 
      :budgetType="budgetType" 
      v-on:modal="(record) => $emit('modal',record)"
      v-on:order="order"
    ></TableResults>
  </div>
</div>
</template>

<script>

import {gmapApi} from 'vue2-google-maps'
import OpenData from '@/libraries/OpenData';
import TableResults from './TableResults.vue';

const WINNIPEG_CENTRE = {lat: 49.86, lng: -97.158465};
const GROWTH_ENABLED = "Growth-enabling infrastructure";
const GROWTH_SUPPORTING = "Growth-supportive infrastructure";
const HIGH_POVERTY_AREA = "Higher Poverty Area";

export default {
    props: ["wheres", "budgetType"],
    components: { TableResults },
    data() {
        return {
            zoom: 11,
            centre: WINNIPEG_CENTRE,
            polygon_default_options: {
                strokeOpacity: 0.5,
                strokeWeight: 1,
                fillOpacity: 0.6,
                fillColor: "black",
            },
            loading: false,
            currentFillMap: "greenfield",
            growthType: "All",
            fill_areas: {
                "high_poverty_area": {
                  url: "https://data.winnipeg.ca/resource/gg4w-peq6.json",
                  params: { where_parameters: [
                    [
                      { column: 'is_high_poverty_area', type: '=', params: ['true']},
                      { column: 'is_concentrated_poverty_area', type: '=', params: ['true']},
                    ]
                  ]},
                  data: [],
                  label_column: "high_poverty_status",
                  data_column: "location",
                },
                "wards": {
                  url: "https://data.winnipeg.ca/resource/t4cg-yaxs.json",
                  params: { },
                  data: [],
                  label_column: "name",
                  data_column: "the_geom",
                },
                "intensification_targets": {
                  url: "https://data.winnipeg.ca/resource/uyiy-tujz.json",
                  params: { },
                  data: [],
                  label_column: "year",
                  data_column: "location",
                },
                "greenfield": {
                  url: "https://data.winnipeg.ca/resource/6d7u-75tm.json",
                  params: { },
                  data: [],
                  label_column: "term",
                  data_column: "location",
                },
            },
            records: [],
            map_data: [],
            infoWindowPos: null,
            infoWinOpen: false,
            currentMidx: null,
            sort: {
                column: "sum_capital_cost",
                direction: "DESC",
            },
            infoOptions: {
              content: '',
            //optional: offset infowindow so it visually sits nicely on top of our marker
              pixelOffset: {
                width: 0,
                height: -35
              }
          },
        };
    },
    created() {
        this.fetch();
        this.get_fill_area();

    },
    watch: {
        parameters() {
            this.fetch();
        },

        currentFillMap() {
          this.get_fill_area();
        }
    },
    computed: {
        location_records() {
            return this.records.filter(row => row.location).map(row => {
                row.position = { lat: row.location.coordinates[1], lng: row.location.coordinates[0] };
                row.percent_funded = row.sum_funded / row.sum_capital_cost;
                return row;
            });
        },

        citywide_records() {
            return this.records.filter(row => !row.location);
        },

        geometry_data() {
          if (this.currentFillMap === 'intensification_targets') {
            const data = this.map_data;
            //This hack is so we don't have to change the data for this one map
            data[0]['year'] = this.$t('intensification_target_label');
          }
          return this.map_data;
        },

        geometry_labels() {
          const current = this.fill_areas[this.currentFillMap];
          return [... new Set(this.geometry_data.map(row => row[current.label_column]))]
        },

        geometry_colours() {
          const colorArray = [];
          for (let i = 0; i < this.geometry_labels.length; i++) {
            const hue = ((i + 1) * (360/this.geometry_labels.length)) % 360;
            const color = `hsl(${hue}, 70%, 50%)`;
            colorArray.push(color);
          }
          return colorArray;
        },

        geometry_options() {
          const labels_reversed = {};
          this.geometry_labels.forEach((element,idx) => {
            labels_reversed[element] = idx;
          });
          const current = this.fill_areas[this.currentFillMap];

          return this.geometry_data.map(row => {
            let options = Object.assign({}, this.polygon_default_options);
            let geometry_label = row[current.label_column];
            options.fillColor = this.geometry_colours[labels_reversed[geometry_label]];
            return options;
          })
        },

        polygons() {
          if (this.loading) {
            return [];
          }
          const current = this.fill_areas[this.currentFillMap];
          let polygons = [];
          if (this.geometry_data && this.geometry_data.length) {
            polygons = this.geometry_data.map(item => {

              let coordinates = (item[current.data_column].type === "Polygon") ? 
                item[current.data_column].coordinates[0] :
                item[current.data_column].coordinates[0][0];
              return coordinates.map(entry => {
                return {
                  lat: parseFloat(entry[1]),
                  lng: parseFloat(entry[0])
                }
              });
            });
          }
          return polygons;
        },

        group_parameters() {
            return {
                select: ['investment_name','department','service_area','investment_type','spap_theme','lifecycle_activity_driver','class_estimate','ward', 'location','project_details'],
                function_column: ['capital_cost','funded','unfunded','previously_approved_project_funding',
                            'preliminary_capital_cost_6_year','preliminary_capital_cost_10_year',
                            'preliminary_funded_6_year','preliminary_funded_10_year',
                            'preliminary_unfunded_6_year','preliminary_unfunded_10_year'],
                function: ['sum','sum','sum','sum',
                      'sum','sum','sum','sum','sum','sum'],
                group: ['investment_name','department','service_area','investment_type','spap_theme','lifecycle_activity_driver','class_estimate','ward', 'location','project_details']
            }
        },

        order_parameters() {
            return [{ key: this.sort.column, direction: this.sort.direction }];
        },

        where_parameters() {
            let where_parameters = [...new Set(this.wheres)];
            if (this.growthType === GROWTH_ENABLED) {
              where_parameters.push([{column: 'growth_enabling_or_supportive', type:'=', params:[GROWTH_ENABLED]}]);
            }
            if (this.growthType === GROWTH_SUPPORTING) {
              where_parameters.push([{column: 'growth_enabling_or_supportive', type:'=', params:[GROWTH_SUPPORTING]}]);
            }
            if (this.growthType === HIGH_POVERTY_AREA) {
              where_parameters.push([{column: 'gahp', type:'=', params:['Y']}]);
            }
            return where_parameters;
        },

        parameters() {
            let where_parameters = this.where_parameters;
            let group_parameters = this.group_parameters;
            let order_parameters = this.order_parameters;
            return { where_parameters, group_parameters, order_parameters };
        },
        google: gmapApi
    },

    methods: {

      order(column,direction) {
        this.sort.column = column;
        this.sort.direction = direction;
      },

      async get_fill_area() {
        const current = this.fill_areas[this.currentFillMap];
        if (current.data.length) {
          this.map_data = current.data;
        } else {
          const url = current.url;
          const query_params = current.params;
          this.loading = true;
          const data = await OpenData.getResults(url,query_params);
          this.loading = false;
          this.fill_areas[this.currentFillMap].data = data;
          this.map_data = data;
        }
      },

      async fetch() {
          const params = this.parameters;
          this.loading = true;
          const data = await OpenData.getResults(this.$OPEN_DATA_API, params);
          this.records = data;
          this.loading = false;
      },

      polygon_clicked(polygon, index) {
        const key = 'poly_' + index;
        const current = this.fill_areas[this.currentFillMap];
        const description = this.geometry_data[index][current.label_column];
        const content = `<div id="infoWindow" class="p-2">
          <p class="h3">${this.$t(this.currentFillMap + '_description',{ val: description})}</p>
          </div>`;
        this.toggleInfoWindow({ position: polygon[0], content: content}, key, 0);
      },
      
      marker_clicked(marker,index) {
        const key = 'marker_' + index;
        const content = `<div id="infoWindow" class="p-2">
          <p class="h3">${marker.investment_name}</p>
          <button type="button" class="btn btn-primary">${this.$t('See more info')}</button>
        </div>`;
        marker.content = content;
        this.toggleInfoWindow(marker, key);
      },

      toggleInfoWindow(marker, key) {
        this.infoWindowPos = marker.position;
        this.infoOptions.content = marker.content;

        //check if its the same marker that was selected if yes toggle
        if (this.currentMidx == key) {
          this.infoWinOpen = !this.infoWinOpen;
        }
        //if different marker set infowindow to open and reset current marker index
        else {
          this.infoWinOpen = true;
          this.currentMidx = key;
        }

        if (this.infoWinOpen) {
          this.$nextTick(() => {
            document.getElementById('infoWindow').addEventListener('click', () => {
              this.info_clicked(marker);
            })
          })
        }
      },
      info_clicked(marker) {
        this.$emit('modal',marker);
      },

      marker_options(record) {
        const colour = (record.percent_funded <= 0) ? '#CE2334' : ((record.percent_funded >= 1) ? '#00AB4E' : '#FFB71B');
        return {
          icon: {
            // eslint-disable-next-line
            path: this.google.maps.SymbolPath.CIRCLE,
            fillColor: colour,
            fillOpacity: 1,
            strokeWeight: 1,
            scale: 6
          },
          title: record.investment_name,
        }
      }
    },
}
</script>

<style>
.dsred { color: #CE2334 }
.dsyellow { color: #FFB71B }
.dsgreen { color: #00AB4E }
#infoWindow p.h3 { margin-top: 0px }
</style>